import axios, { API_URL } from '../../services/axios';
import { NetworkContext } from '../../types/network';
import { AppThunk } from '../store';
import { setLoading, setViewings, setError, SaleType } from './viewings.slice';

type OpenViewingSearch = (
  imageLocator: string,
  date?: string,
  type?: SaleType,
  t?: number | null,
  ctx?: NetworkContext,
) => AppThunk<Promise<boolean>>;

export const openViewings: OpenViewingSearch = (imageLocator, date, type, t, ctx) => async (dispatch) => {
  dispatch(setLoading(true));

  const term = t || undefined;
  const saleType = type || 1;

  try {
    const res = await axios(
      {
        url: `${API_URL}/open-viewings?imageLocator=${encodeURIComponent(imageLocator)}`,
        params: {
          date,
          saleType,
          term,
        },
      },
      dispatch,
      ctx,
    );

    dispatch(
      setViewings({
        data: res.data,
        loading: false,
        date,
        saleType,
        term,
      }),
    );
    return true;
  } catch (err: any) {
    dispatch(setError(err));
    return false;
  }
};

export default { openViewings };
